import { gql } from '@apollo/client';
import { Fragments } from 'api/fragments';

export const SWITCH_UI = gql`
  mutation updateLab($name: String, $enable: Boolean!) {
    toggleLab(name: $name, enable: $enable) {
      id
      name
      enabled
    }
  }
`;

export const SET_THEME = gql`
  mutation setTheme($scope: Scope!, $settings: DisplaySettingsInput!) {
    setDisplaySettings(scope: $scope, settings: $settings) {
      theme
    }
  }
`;

export const SET_PREFERENCES = gql`
  mutation setPreferences($homepages: [PreferenceHomepageInput], $timezone: String) {
    updatePreferences(homepages: $homepages, timezone: $timezone) {
      homepages {
        team
        path
      }
      timezone
    }
  }
`;

const SAVED_SEARCHES_QUERY_BODY = `
    privateSearches: savedSearches(type: PRIVATE) {
        name
        url
        index
    }
    sharedSearches: savedSearches(type: SHARED) {
        name
        url
        index
    }
`;

export const SAVED_SEARCHES_QUERY = gql`
  query getSavedSearches {
    ${SAVED_SEARCHES_QUERY_BODY}
  }
`;

export const DELETE_SEARCH = gql`
  mutation DeleteSavedSearch($name: String!, $type: SavedSearchType!, $index: Int!) {
    deleteSavedSearchV2(name: $name, type: $type, index: $index) {
      name
      url
      index
    }
  }
`;

export const USER_DATA_QUERY = gql`
  query navBarData {
    account: accountData {
      id
      email
      status
      type
      trialExpiresAt
      masterAccountId
      isEmailVerified
      isEmailVerificationRequired
      activeTeamPermission
      dataAvailability
      isSingularityXDRUser
      S1ConsoleURL
      activeTeamV2 {
        emailAddress
        id
        name
      }
      teamsV2 {
        emailAddress
        id
        name
      }
      planData {
        retention
      }
    }
    alertsConfig {
      defaultAlertAddress
    }
    featurePermissions {
      dashboards
      logs
      alerts
      search
      privateSearches
      sharedSearches
    }
    dashboardsV2 {
      name
      tabs {
        tabName
      }
    }
    ${SAVED_SEARCHES_QUERY_BODY}
    labs {
      ...Lab
    }
  }
  ${Fragments.Lab}
`;
